class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.loading = false;
  }

  connectedCallback() {
    this.grid = document.getElementById('product-grid');
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !this.loading) this.loadMore();
      },
      { rootMargin: '600px' }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  get marker() {
    return this.querySelector('[data-next-url]');
  }

  async loadMore() {
    const marker = this.marker;
    const url = marker ? marker.getAttribute('data-next-url') : null;
    if (!url) {
      this.observer.disconnect();
      return;
    }

    this.loading = true;
    this.setAttribute('loading', '');

    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const newGrid = html.getElementById('product-grid');
      if (newGrid && this.grid) this.grid.append(...newGrid.children);

      // Advance to the page after this one, or stop if there are no more.
      const nextMarker = html.querySelector('infinite-scroll [data-next-url]');
      if (nextMarker) {
        marker.setAttribute('data-next-url', nextMarker.getAttribute('data-next-url'));
      } else {
        marker.remove();
        this.observer.disconnect();
      }
    } catch (e) {
      console.error('[infinite-scroll]', e);
    } finally {
      this.loading = false;
      this.removeAttribute('loading');
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
